export const SPOT_PURCHASES_FOR_WO_TC = 'spotPurchasesForWO';
